import { actionsStyles as styles } from "@insite/content-library/Widgets/QuickOrder/QuickOrderActions";

styles.addToListButton = {
    ...styles.addToListButton,
    variant: "secondary",
};
